import { useActivityListener } from './hooks/useActivityListener';
import { useEditMessageKeyListener } from './hooks/useEditMessageKeyListener';
import { useSocketListener } from './hooks/useSocketListener';

export const ConversationListeners = () => {
  useActivityListener();
  useEditMessageKeyListener();
  useSocketListener();

  return null;
};
